import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { GlobalStyles, ThemeProvider } from "@mui/material";
import theme from "./config/theme_config.ts";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import "./index.css";
import { Provider } from "react-redux";
import store from "./store/store.ts";
import { queryClient } from "./config/config.ts";
import configureSentry from "./Sentry/sentry_config.ts";
configureSentry();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <GlobalStyles
          styles={{
            html: {
              fontSize: "16px",
              "@media (min-width:1920px)": {
                fontSize: "19.2px",
              },
              "@media (min-width:2560px)": {
                fontSize: "21.4px",
              },
            },
          }}
        />
        <App />

        {/* </StrictMode> */}
        <ReactQueryDevtools initialIsOpen={false} position="top-right" />
      </QueryClientProvider>
    </Provider>
  </ThemeProvider>,
);
